import { StyledDotsLoadingRoot } from './styles'

const DotsLoading = () => {
    return <StyledDotsLoadingRoot />
}

export default DotsLoading
